import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { TradingDayInfo } from '../entities/trading-day-info.entity';

@Injectable({ providedIn: 'root' })
export class CalendarInfrastructure {
  constructor(private _http: HttpClient) {}

  public getHolidays(): Observable<string[]> {
    return this._http.get<string[]>(`${environment.apihost}/api/calendar/futurenontradingdays`);
  }

  public getTradingDayInfo(isin: string): Observable<TradingDayInfo> {
    return this._http.get<TradingDayInfo>(`${environment.apihost}/api/calendar/tradingDayInfo?isin=${isin}`);
  }
}
